import { jsx as r } from "react/jsx-runtime";
import { Icon as m } from "../../../../components/Icon/index.js";
import { ToolbarButton as s } from "../../styles.js";
import { useQuillActiveFormat as a } from "../../hooks/useQuillActiveFormat/index.js";
import { ListUl as c, ListOl as d } from "@pelando/fontawesome/icons";
import { useTranslation as p } from "../../../../hooks/useTranslation/index.js";
const b = (t) => ({
  bullet: c,
  ordered: d
})[t], e = (t) => ({
  bullet: "list-button-unordered",
  ordered: "list-button-ordered"
})[t];
function g({ quill: t, list: o }) {
  const { t: n } = p("common"), i = a(t);
  return /* @__PURE__ */ r(
    s,
    {
      type: "button",
      "aria-pressed": i.list === o,
      title: n(e(o)),
      onClick: () => {
        t == null || t.format("list", o);
      },
      children: /* @__PURE__ */ r(m, { icon: b(o), "aria-label": e(o) })
    }
  );
}
export {
  g as ListButton
};
